// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"DesktopMenu_buttonWrapper__DXWbZ","phoneInside":"DesktopMenu_phoneInside__4oFQi","phoneOutside":"DesktopMenu_phoneOutside__tJUL1"};